import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { PathItem } from './../builders/path_item_builder';
import { PathTask } from './../builders/path_task_builder';
import { PathTopic } from './../builders/path_topic_builder';
import { TodoDateRangeService } from './../services/todo_date_range_service';

interface ILoadPathTasksPayload {
  data: {
    item: PathItem[];
    task: PathTask[];
    topic: PathTopic[];
  };
}

angular
  .module('data-ng-todos')
  .factory(
    'loadPathTasksCommand',
    function loadPathTasksCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngTodoDateRangeService: TodoDateRangeService,
      ngPathItemDatastore: IDatasource<PathItem>,
      ngPathTopicDatastore: IDatasource<PathTopic>,
      ngPathTaskDatastore: IDatasource<PathTask>,
      ngOverduePathTaskDatastore: IDatasource<PathTask>,
      pathTasksVisibilityModel: any,
      TaskStatusEnum: any
    ): void {
      return defineCommand(
        'loadPathTasksCommand',
        function loadPathTasksCommand(deferred: ng.IDeferred<any>, formattedDateRange: any, status: any): any {
          status = status || TaskStatusEnum.ACTIVE;
          let data: any = {
            status: status.key.toUpperCase()
          };

          formattedDateRange = formattedDateRange || ngTodoDateRangeService.getCurrentDateRange();

          if (formattedDateRange) {
            data = _.merge(data, {
              start_dt: formattedDateRange.start,
              end_dt: formattedDateRange.end
            });
          }

          $http
            .get('/event/tasks/', {
              params: data
            })
            .then((response: ILoadPathTasksPayload): void => {
              pathTasksVisibilityModel.clear();

              if (TaskStatusEnum.isOverdue(status)) {
                ngOverduePathTaskDatastore.write(response.data.task);
              } else {
                ngPathTaskDatastore.write(response.data.task);
              }

              ngPathItemDatastore.write(response.data.item);
              ngPathTopicDatastore.write(response.data.topic);
              ORM.run();

              deferred.resolve(response.data);
            })
            .catch((response: any) => {
              deferred.reject(response.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_path_tasks_command.ts